// extracted by mini-css-extract-plugin
export default {"table":"table__RGIr3_","rolesModal":"rolesModal__SOtwD2","saveButton":"saveButton__IMmJ51","spinnerIcon":"spinnerIcon__b55q5h","hiddenField":"hiddenField__dB713O"};